module.exports = __webpack_public_path__ + "img/horizontal_4_2_5010.ed14167c.png";